<template>
    <el-dialog title="详情" :visible.sync="dialogFormVisible" width="650px" @close="handleDialog" :close-on-click-modal="false">
        <el-table :data="rander" border :show-header="false">
            <el-table-column prop="key" width="200"></el-table-column>
            <el-table-column prop="value">
                <template slot-scope="{row}">
                    <div v-if="['通用码', '礼包ID'].includes(row.key)">
                        {{ row.value }}
                        <i class="el-icon-document-copy" v-if="row.value" @click="doCopy(row.value)"></i>
                    </div>
                    <div v-else>{{ row.value }}</div>
                </template>
            </el-table-column>
        </el-table>
    </el-dialog>
</template>

<script>
import moment from 'moment';
import {mapState} from 'vuex';
export default {
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        detailRowData: {
            type: Object,
            default: () => {}
        },
        dialogCategory: {
            type: Boolean,
            default: null
        },
    },
    data() {
        return {
            dialogFormVisible: false,
            data: [],
        };
    },
    watch: {
        dialogVisible(newVal) {
            this.dialogFormVisible = newVal;
        }
    },
    computed: {
        ...mapState(['$page']),
        pageCategory() {
            /**
             * 区分CP 导入 还是自生成码  (push = CP导入 & self-generated = 自生成)
             */
            let category = this.$page === 'recharge/pushRechargeCodeList' ? 'push' : 'self-generated';
            return category;
        },
        rander() {
            if (!Object.keys(this.detailRowData).length) {
                return [];
            }
            let options = [{
                key: '兑换充值码的操作系统',
                value: this.detailRowData.exchange_type ? '我司提供' : 'cp提供'
            }, {
                key: '礼包ID',
                value: this.detailRowData.gift_id
            },
            {
                key: '活动名称',
                value: this.detailRowData.activity_name
            },
            {
                key: '礼包名称',
                value: this.detailRowData.gift_name
            },
            {
                key: 'CD key',
                value: this.detailRowData.cdkey
            },
            {
                key: '充值码类型',
                value: !this.detailRowData.type ? '通用码' : '单次码'
            },
            {
                key: '通用码',
                value: this.detailRowData.code
            },
            {
                key: '使用纬度',
                value: this.detailRowData.use_dimension ? 'Role ID' : 'Player ID'
            },
            {
                key: '同一账号支持领取多码',
                value: this.detailRowData.use_times ? '是' : '否'
            },
            {
                key: '充值码总数',
                value: this.detailRowData.total
            },
            {
                key: '剩余数量',
                value: this.detailRowData.left_total
            },
            {
                key: '开始时间',
                value: this.detailRowData.start_time? moment(this.detailRowData.start_time, 'X').format('YYYY-MM-DD HH:mm:ss'): '永久'
            },
            {
                key: '结束时间',
                value: this.detailRowData.end_time? moment(this.detailRowData.end_time, 'X').format('YYYY-MM-DD HH:mm:ss'): '永久'
            },
            {
                key: '启用状态',
                value: this.detailRowData.status ? '启用' : '关闭'
            },
            {
                key: '服范围',
                value: this.detailRowData.allow_server ? this.detailRowData.allow_server : '--'
            },
            {
                key: '角色vip等级',
                value: this.detailRowData.allow_viplevel ? this.detailRowData.allow_viplevel : '--'
            },
            {
                key: '最近操作人',
                value: this.detailRowData.operator ? this.detailRowData.operator : '--'
            },
            {
                key: '最近操作时间',
                value: this.detailRowData.updated_time? moment(this.detailRowData.updated_time, 'X').format('YYYY-MM-DD HH:mm:ss'): '--'
            }];
            if(this.pageCategory === 'self-generated') {
                options.splice(0, 1);
            }
            if (this.detailRowData.type) {
                options = options.filter((item) => {
                    if (this.pageCategory === 'push') {
                        if (this.detailRowData.exchange_type) {
                            return !(item.key === '通用码') && !(item.key === '充值码类型');
                        }
                        else {
                            return !(item.key === '通用码') && !(item.key === '充值码类型') && !(item.key === 'CD key');
                        }
                    }
                    else {
                        return !(item.key === '通用码');
                    }
                });
            }
            else {
                options = options.filter((item) => {
                    return !(item.key === '同一账号支持领取多码');
                });
            }
            return options;
        }
    },
    methods: {
        handleDialog() {
            this.dialogFormVisible = false;
            this.$emit('changeDialogVisible', false);
        },
        doCopy(code) {
            this.$emit('doCopy', code);
        }
    },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// website/subComponents/recharge/detail.vue